export const getEffectiveSort = (
  sortKey,
  sortDirection,
  defaultKey,
  defaultDirection = 'desc'
) => ({
  key: sortKey || defaultKey,
  direction: sortDirection || defaultDirection,
});

const normalizeSortableValue = (value) => {
  if (value === null || value === undefined) return null;
  if (value instanceof Date) return value.getTime();
  if (typeof value === 'number') return value;
  if (typeof value === 'boolean') return value ? 1 : 0;

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '';

    const asDate = Date.parse(trimmed);
    if (!Number.isNaN(asDate) && /\d/.test(trimmed)) {
      return asDate;
    }

    const numericCandidate = Number(
      trimmed
        .replace(/\s+/g, '')
        .replace(/%/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
    );
    if (
      !Number.isNaN(numericCandidate) &&
      /^-?[0-9]+([.,][0-9]+)?$/.test(trimmed)
    ) {
      return numericCandidate;
    }

    return trimmed.toLowerCase();
  }

  if (typeof value === 'object') {
    if (value.value !== undefined) return normalizeSortableValue(value.value);
    if (value.label !== undefined) return normalizeSortableValue(value.label);
  }

  return value;
};

export const sortRowsByKey = (
  rows,
  sortKey,
  sortDirection = 'asc',
  getValue
) => {
  if (!Array.isArray(rows) || !rows.length || !sortKey || !sortDirection) {
    return rows;
  }

  const sorted = [...rows].sort((a, b) => {
    const rawA = getValue ? getValue(a, sortKey) : a?.[sortKey];
    const rawB = getValue ? getValue(b, sortKey) : b?.[sortKey];

    const valA = normalizeSortableValue(rawA);
    const valB = normalizeSortableValue(rawB);

    if (valA === valB) return 0;
    if (valA === null || valA === undefined || valA === '') return 1;
    if (valB === null || valB === undefined || valB === '') return -1;

    if (valA > valB) return sortDirection === 'asc' ? 1 : -1;
    if (valA < valB) return sortDirection === 'asc' ? -1 : 1;
    return 0;
  });

  return sorted;
};
